import React from 'react';
import Switch, { SwitchProps } from '@mui/material/Switch';
import { FormControl, FormLabel, Typography, styled } from '@mui/material';
import { GREEN_500, RED_500 } from '../../constants/Colors';
import { t } from 'i18next';

interface BakeasySwitchProps {
  label?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  variant?: any;
  style?: React.CSSProperties;
  value: boolean;
  onChange?: ((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void) | undefined;
}

function BakeasySwitch(props: BakeasySwitchProps) {
  const AntSwitch = styled((props: SwitchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  ))(({ theme }) => ({
    width: 32,
    height: 18,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': { width: 15 },
      '& .MuiSwitch-switchBase.Mui-checked': { transform: 'translateX(9px)' }
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(14px)',
        color: '#fff',
        '& + .MuiSwitch-track': { opacity: 1, backgroundColor: GREEN_500 }
      }
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 14,
      height: 14,
      borderRadius: 8,
      transition: theme.transitions.create(['width'], { duration: 200 })
    },
    '& .MuiSwitch-track': {
      borderRadius: 18 / 2,
      opacity: 1,
      backgroundColor: RED_500,
      boxSizing: 'border-box'
    }
  }));

  return (
    <Typography sx={{ fontSize: 14 }} component={'span'}>
      <FormControl sx={{ flexDirection: 'row', alignItems: 'center' }}>
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props.label == 'No / Yes' ? t('NO') : ''}
        </FormLabel>

        <AntSwitch checked={props?.value} onChange={props?.onChange} disabled={props?.disabled} />
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props.label == 'No / Yes' ? t('YES') : ''}
        </FormLabel>
      </FormControl>
    </Typography>
  );
}

export default BakeasySwitch;
